<template>
  <div style="height: 100%">
  </div>
</template>

<script>
export default {
  name: "EventList",
  components: {  },
  data() {
    return {
    };
  },
  created() {
    this.initDataStatic();
  },
  methods: {
    initDataStatic() {
      const me = this;
    },
  },
};
</script>

<style lang="scss" scoped></style>
